// Handle SVG LazyLoading
const promiseCache = {}; // Cache for storing loaded SVG promises

// Function to set classes and attributes
function setAttributesAndClasses(svgElement, classList, attributes) {
    svgElement.setAttribute("class", classList.join(" "));
    attributes.forEach(attr => {
        svgElement.setAttribute(attr.name, attr.value);
    });
}

// Function to handle SVG scripts (if any)
function handleSvgScripts(svgElement) {
    const scriptElement = svgElement.querySelector('script');
    if (scriptElement) {
        const newScript = document.createElement('script');
        newScript.type = 'text/javascript';
        if (scriptElement.textContent.startsWith('<![CDATA[') && scriptElement.textContent.endsWith(']]>')) {
            newScript.textContent = scriptElement.textContent.slice(9, -3);
        } else {
            newScript.textContent = scriptElement.textContent;
        }
        document.head.appendChild(newScript);
        document.head.removeChild(newScript);
    }
}

// Load a single SVG container - returns a promise
function loadSVG(container) {
    const svgSrc = container.getAttribute("data-src");
    if (!svgSrc) return Promise.resolve();

    const classList = Array.from(container.classList).filter(className => className !== "svg-container");
    const attributes = Array.from(container.attributes).filter(attr => attr.name !== "data-src" && attr.name !== "class");

    // Check if SVG content is already cached
    if (promiseCache[svgSrc]) {
        return promiseCache[svgSrc].then(svgContent => {
            if (svgContent) {
                const svgElement = svgContent.cloneNode(true);
                setAttributesAndClasses(svgElement, classList, attributes);
                container.replaceWith(svgElement);
                handleSvgScripts(svgElement);
            }
        });
    }

    // If not cached, fetch SVG content
    const fetchPromise = fetch(svgSrc)
        .then(response => {
            if (response.ok) return response.text();
            throw new Error(`Failed to load SVG`);
        })
        .then(svgText => {
            return new DOMParser().parseFromString(svgText, "image/svg+xml").documentElement;
        })
        .catch(() => null);

    // Cache the fetch promise
    promiseCache[svgSrc] = fetchPromise;

    // Once SVG content is loaded, replace the container
    return fetchPromise.then(svgElement => {
        if (svgElement) {
            setAttributesAndClasses(svgElement, classList, attributes);
            container.replaceWith(svgElement);
            handleSvgScripts(svgElement);
        }
    });
}

// Load all SVGs within a container - returns a promise that resolves when all are loaded
function loadAllSVGsIn(parentElement) {
    const containers = parentElement.querySelectorAll('.svg-container');
    return Promise.all(Array.from(containers).map(loadSVG));
}

// Export for use in other modules
window.loadAllSVGsIn = loadAllSVGsIn;

window.addEventListener("load", function() {
    const svgContainers = document.querySelectorAll(".svg-container");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadSVG(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    svgContainers.forEach(container => {
        observer.observe(container);
    });
});
